module.exports = __webpack_public_path__ + "img/furnitures.444bc8a2.png";